<template>
    <div class="appoint-project-list">
        <div class="header">
            <h2>预约项目列表</h2>
            <a-button type="primary" @click="createProject">新增预约项目</a-button>
        </div>
        <div class="table-wrapper">
            <a-table :columns="columns" :data-source="list" :pagination="pagination" :row-key="record => record.id">
                <template slot="serialNumber" slot-scope="text, record, index">
                    {{ (pagination.current - 1) * pagination.pageSize + index + 1 }}
                </template>
                <template slot="created_at" slot-scope="text">
                    {{ formatDate(text) }}
                </template>
                <template slot="teachers" slot-scope="teachers">
                    <div class="teacher-box">
                        <div class="teacher-item">
                            <template v-for="(teacher, i) in teachers">
                                <div class="avatar" :key="teacher.id" v-if="i <= 2 && teacher">
                                    <img v-if="teacher.avatar" :src="teacher.avatar" />
                                </div>
                            </template>

                        </div>
                        <div class="teacher-num">共{{ teachers.length }}人</div>
                    </div>
                </template>
                <template slot="type" slot-scope="type">
                    <img src="/assets/icons/icon-flexible.png" style="width: 20px;height: 20px;"
                        v-if="type == 'flexible'" />
                    <img src="/assets/icons/icon-fixed.png" style="width: 20px;height: 20px;" v-else />
                    {{ type === 'flexible' ? '随用随约' : '固定班次' }}
                </template>
                <template slot="rules" slot-scope="text, record">
                    <span class="appointment-rule" :class="{ 'fixed-schedule': record.type === 'fixed' }">
                        <template v-if="record.type === 'fixed'">
                            共{{ record.schedules.length }}班次丨每班{{ record.schedules[0].max_count }}人
                        </template>
                        <template v-else>
                            共{{ record.available_times.length }}班次丨单次{{ record.duration }}分钟
                        </template>
                    </span>
                </template>
                <template slot="completed_count" slot-scope="text">
                    {{ text || 0 }}
                </template>
                <template slot="pending_count" slot-scope="text">
                    {{ text || 0 }}
                </template>
                <template slot="status" slot-scope="text, record">
                    <a-switch :loading="loadingStatus[record.id]" checked-children="开" un-checked-children="关"
                        :checked="record.status === 1" @change="handleStatusChange(record)" />
                </template>
                <template slot="action" slot-scope="action">
                    <div class="op-box">
                        <div class="op-item" @click="editProject(action)">
                            <img src="/assets/icons/input-edit.png" />
                        </div>
                        <div class="op-item" @click="deleteProject(action.id)">
                            <img src="/assets/icons/input-del.png" />
                        </div>
                    </div>
                </template>
            </a-table>
        </div>
        <ProjectCreate ref="projectCreate" @save-success="getList" />
    </div>
</template>

<script>
import api from '@/repo/api';
import ProjectCreate from './components/create.vue';
import moment from 'moment';

export default {
    name: 'AppointProjectList',
    components: {
        ProjectCreate
    },
    data() {
        return {
            list: [],
            loadingStatus: {}, // 用于跟踪每个项目的loading状态
            pagination: {
                current: 1,
                pageSize: 10,
                showSizeChanger: true,
                showQuickJumper: true,
                showTotal: (total) => `共 ${total} 条数据`,
                pageSizeOptions: ['10', '20', '50', '100'],
                onChange: this.handlePageChange,
                onShowSizeChange: this.handleSizeChange,
                total: 0
            },
            columns: [
                {
                    title: '序号',
                    key: 'serialNumber',
                    dataIndex: '',
                    scopedSlots: { customRender: 'serialNumber' },
                    // width: 48,
                    align: 'center'
                },
                {
                    title: '创建项目时间',
                    key: 'created_at',
                    dataIndex: 'created_at',
                    scopedSlots: { customRender: 'created_at' },
                    // width: 126,
                    align: 'center'
                },
                {
                    title: '项目名称',
                    key: 'name',
                    dataIndex: 'name',
                    // width: 138,
                    align: 'center'
                },
                {
                    title: '项目老师',
                    key: 'teachers',
                    dataIndex: 'teachers',
                    scopedSlots: { customRender: 'teachers' },
                    width: 120,
                    align: 'center'
                },
                {
                    title: '预约模式',
                    key: 'type',
                    dataIndex: 'type',
                    scopedSlots: { customRender: 'type' },
                    // width: 100,
                    align: 'center'
                },
                {
                    title: '预约规则',
                    key: 'rules',
                    dataIndex: 'rules',
                    scopedSlots: { customRender: 'rules' },
                    width: 160,
                    align: 'center'
                },
                {
                    title: '已完成人数',
                    key: 'completed_count',
                    dataIndex: 'completed_count',
                    scopedSlots: { customRender: 'completed_count' },
                    // width: 100,
                    align: 'center'
                },
                {
                    title: '待交付人数',
                    key: 'pending_count',
                    dataIndex: 'pending_count',
                    scopedSlots: { customRender: 'pending_count' },
                    // width: 100,
                    align: 'center'
                },
                {
                    title: '启用',
                    key: 'status',
                    dataIndex: 'status',
                    scopedSlots: { customRender: 'status' },
                    //  width: 50,
                    align: 'center'
                },
                {
                    title: '操作',
                    key: 'action',
                    scopedSlots: { customRender: 'action' },
                    width: 70,
                    align: 'center'
                }
            ]
        };
    },
    mounted() {
        this.getList();
    },
    methods: {
        getList() {
            const params = {
                page: this.pagination.current,
                pageSize: this.pagination.pageSize
            };
            api.get('/ast-appointment/appointment-list', params).then(res => {
                if (res.code === 0) {
                    this.list = res.data.data || [];
                    this.pagination.total = res.data.total || 0;
                }
            }).catch(() => {
                this.$message.error('网络异常，请重试');
            });
        },
        handlePageChange(page) {
            this.pagination.current = page;
            this.getList();
        },
        handleSizeChange(current, size) {
            this.pagination.current = current;
            this.pagination.pageSize = size;
            this.getList();
        },
        formatDate(dateString) {
            if (!dateString) return '';
            return moment(dateString).format('YYYY/MM/DD  HH:mm');
        },
        createProject() {
            this.$refs.projectCreate.open();
        },
        editProject(record) {
            this.$refs.projectCreate.open(record);
        },
        handleStatusChange(record) {
            // 设置当前项目的loading状态为true
            this.loadingStatus = {
                ...this.loadingStatus,
                [record.id]: true
            };

            const status = record.status === 1 ? 0 : 1;
            api.post('/ast-appointment/appointment-status', { id: record.id, status }).then(res => {
                if (res.code === 0) {
                    this.getList();
                } else {
                    this.$message.error(res.msg || '状态更新失败');
                    // 失败时恢复状态
                    record.status = record.status === 1 ? 0 : 1;
                }
            }).catch(() => {
                this.$message.error('网络异常，请重试');
                // 失败时恢复状态
                record.status = record.status === 1 ? 0 : 1;
            }).finally(() => {
                // 请求结束后设置loading状态为false
                this.loadingStatus = {
                    ...this.loadingStatus,
                    [record.id]: false
                };
            });
        },
        deleteProject(id) {
            this.$confirm({
                title: '确认删除',
                content: '确定要删除该预约项目吗？删除后将无法恢复。',
                okText: '确定',
                cancelText: '取消',
                onOk: () => {
                    api.post('/ast-appointment/appointment-delete', { id }).then(res => {
                        if (res.code === 0) {
                            this.$message.success('删除成功');
                            this.getList();
                        } else {
                            this.$message.error(res.msg || '删除失败');
                        }
                    }).catch(() => {
                        this.$message.error('网络异常，请重试');
                    });
                }
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.appoint-project-list {
    width: 100%;
    background: #fff;
}

.header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}

.header h2 {
    margin: 0;
    font-size: 18px;
    font-weight: 500;
}

.table-wrapper {
    background: #fff;
}

.op-box {
    width: 70px;
    display: flex;
    justify-content: space-between;

    .op-item {
        width: 24px;
        height: 24px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        img {
            width: 100%;
            height: 100%;
        }
    }
}

.teacher-box {
    width: 120px;
    display: flex;
    justify-content: flex-end;
    position: relative;

    .teacher-item {
        height: 28px;
        display: flex;
        align-items: center;
        position: absolute;
        top: 0;
        right: 52px;

        .avatar {
            width: 32px;
            height: 32px;
            border-radius: 50%;
            border: 1px solid #FFFFFF;
            margin-right: -16px;

            &:last-child {
                margin-right: 0;
            }

            img {
                width: 100%;
                height: 100%;
                border-radius: 50%;
            }
        }
    }

    .teacher-num {
        width: 61px;
        height: 28px;
        line-height: 28px;
        background: #F2F2F2;
        border-radius: 45px;
        text-align: center;
        color: #606266;
        font-size: 14px;
    }
}

/* 表头样式 */
/deep/ .ant-table-thead>tr>th {
    color: #999999;
    font-size: 14px;
    font-weight: 500;
}

/* 数据列样式 */
/deep/ .ant-table-tbody>tr>td {
    padding: 10px 8px;
    color: #606266;
    font-size: 14px;
}

/* 预约规则样式 */
.appointment-rule {
    display: inline-block;
    width: 172px;
    height: 28px;
    background: rgba(209, 185, 155, 0.2);
    border-radius: 35px;
    text-align: center;
    line-height: 28px;
    font-size: 12px;
    color: #606266;
}

/* 固定班次特殊样式 */
.appointment-rule.fixed-schedule {
    background: rgba(127, 191, 191, 0.2);
}
</style>
